export const getDateWithSymbol = (date: Date, symbol: string) => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  return `${year}${symbol}${month.toString().padStart(2, '0')}${symbol}${day
    .toString()
    .padStart(2, '0')}`;
};

export const getHourWithSymbol = (date: Date, symbol: string) => {
  const hour = date.getHours();
  const minute = date.getMinutes();

  return `${hour.toString().padStart(2, '0')}${symbol}${minute
    .toString()
    .padStart(2, '0')}`;
};
